import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var learningTrackListRes;
export const learningTrackListTodo = createAsyncThunk('learningTrackList', async (val) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'course/get_learning_path_list',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "temp": val.temp,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return learningTrackListRes = res.data
    } catch (error) {
        return learningTrackListRes = error.response.data
    }
})


const learningTrackListSlice = createSlice({
    name: 'learningTrackList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(learningTrackListTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('learningTrackList', state.data)
            }
        });
        builder.addCase(learningTrackListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default learningTrackListSlice.reducer; 